import React from "react"

import FormattedMessage from "@irati/utils/lang"
import {RedemptionReportDuration} from "@irati/types"
import {H1} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import {useUserSavings} from "@irati/adminReporting/hooks"
import Loading from "@irati/ui/src/Loading"
import Icon, {IconTypes} from "@irati/ui/src/Icon"

import RedemptionTable from "../components/SavingsTracker/RedemptionTable"
import SavingsWidgets from "../components/SavingsTracker/Widgets"

const LIMIT_ALGOLIA_DEALS = 500

const MySavings = () => {
  const {data, load} = useUserSavings({duration: RedemptionReportDuration.CustomDate, limit: LIMIT_ALGOLIA_DEALS, retrieveAllFields: true})
  if (!data) return null

  return (
    <Loading load={load}>
      <Flex alignItems="center" gap={0.5} marginTop={5} marginBottom={4}>
        <Icon icon={IconTypes.savingsAnimated} size={28} />
        <H1>
          <FormattedMessage id="platform.mySavings.header.copy" />
        </H1>
      </Flex>
      <SavingsWidgets showWidgetInPage brands={data?.brands} currency={data?.savings?.fixed?.currency} />
      <RedemptionTable brands={data.brands} currency={data.savings?.fixed?.currency} />
    </Loading>
  )
}

export default MySavings
